<div class="account-section">
  <div class="my-section-box">

    <div class="my-section-box__headline">{{'dataExtractionRquest.requestor'|cxTranslate}}
    </div>
    <div class="data-extraction__form">
      <div class="my-section-box-inner">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <label class="checkbox">
              <input type="checkbox" [(ngModel)]="sameAsAbove" name="sameAsAbove"
                (change)="setupFormValuesOnCheckboxClick($event)">
                <span class="margin-left-35">{{'requestorForm.checkbox_label'|cxTranslate}}</span>
              </label>
            </div>
          </div>
          <form [formGroup]="requestorForm">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="companyName"
                class="control-label">{{'requestorForm.companyName'|cxTranslate}}</label>
                <div class="input-wrapper-with-icon">
                  <div class="input-with-icon">
                    <input class="form-control" formControlName="companyName" name="companyName"
                                        [ngClass]="{ 'is-valid':(requestorForm?.get('companyName')?.dirty ) && !requestorForm?.get('companyName')?.errors, 
                                                                'is-invalid': (requestorForm?.get('companyName')?.dirty  ) && requestorForm?.get('companyName')?.errors }" />

                      <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                        (click)="openPopupCompanyName()" />
                      </div>
                      @if (
                        requestorForm.get('companyName')?.invalid &&
                        (requestorForm.get('companyName')?.dirty ||
                        requestorForm.get('companyName')?.touched )
                        ) {
                        <div class="invalid-feedback-icon">
                          {{'dataExtractionRquest.error_message'|cxTranslate}}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <label for="contactName"
                    class="control-label">{{'requestorForm.contactName'|cxTranslate}}</label>
                    <div class="input-wrapper-with-icon">
                      <div class="input-with-icon">
                        <input class="form-control" formControlName="contactName" name="contactName"
                                        [ngClass]="{ 'is-valid': (requestorForm?.get('contactName').dirty  ) && !requestorForm?.get('contactName')?.errors, 
                                                                                                            'is-invalid': (requestorForm?.get('contactName').dirty  ) && requestorForm?.get('contactName')?.errors }">
                          <img src="/icons/question_dark_kb.svg" class="info-icon" alt="Back"
                            (click)="openPopupContactName()">
                          </div>
                          @if (
                            requestorForm.get('contactName')?.invalid &&
                            (requestorForm.get('contactName')?.dirty ||
                            requestorForm.get('contactName')?.touched)
                            ) {
                            <div class="invalid-feedback-icon">
                              {{'dataExtractionRquest.error_message'|cxTranslate}}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <label for="email"
                        class="control-label">{{'requestorForm.contactEmail'|cxTranslate}}</label>
                        <input type="email" class="form-control" formControlName="contactEmail"
                                [ngClass]="{ 'is-valid':(requestorForm?.get('contactEmail')?.dirty  ) && !requestorForm?.get('contactEmail')?.errors, 
                                                        'is-invalid': (requestorForm?.get('contactEmail').dirty  ) && requestorForm?.get('contactEmail')?.errors }" />
                          <div class="invalid-feedback">
                            @if ( requestorForm?.get('contactEmail')?.errors && requestorForm?.get('contactEmail')?.errors['required']) {
                              <span class="text-danger-show"
                              >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                            }
                            @if ( requestorForm?.get('contactEmail')?.errors && requestorForm?.get('contactEmail')?.errors['contactEmail']) {
                              <span class="text-danger-show"
                              >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                            }
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <label for="contactPhone"
                          class="control-label">{{'requestorForm.contactPhoneNumber'|cxTranslate}}</label>
                          <input type="text" formControlName="contactPhone" class="form-control" name="contactPhone"
                                [ngClass]="{ 'is-valid': (requestorForm?.get('contactPhone').dirty  ) && !requestorForm?.get('contactPhone')?.errors, 
                                                                            'is-invalid': (requestorForm?.get('contactPhone').dirty  ) && requestorForm?.get('contactPhone')?.errors }">
                            <div class="invalid-feedback">
                              @if ( requestorForm?.get('contactPhone')?.errors && requestorForm?.get('contactPhone')?.errors['required']) {
                                <span class="text-danger-show"
                                >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                              }
                            </div>
                          </div>
                        </div>

                        <div class="row margin-top-25">
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="companyName"
                            class="control-label">{{'requestorForm.companyAddresswithStreetNumber'|cxTranslate}}</label>
                            <input type="text" formControlName="address1" class="form-control" name="companyName"
                              [ngClass]="{ 'is-valid': (requestorForm?.get('address1')?.dirty  ) && !requestorForm?.get('address1')?.errors, 'is-invalid': (requestorForm?.get('address1')?.dirty  ) && requestorForm?.get('address1')?.errors }">
                              <div class="invalid-feedback">
                                @if ( requestorForm?.get('address1')?.errors && requestorForm?.get('address1')?.errors['required']) {
                                  <span class="text-danger-show"
                                  >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                }
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="address2" class="control-label">{{'requestorForm.address2'|cxTranslate}}</label>
                              <input type="text" formControlName="address2" class="form-control" name="address2">
                            </div>
                          </div>

                          <div class="row margin-top-25">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="city" class="control-label">{{'requestorForm.city'|cxTranslate}}</label>
                              <input type="text" formControlName="city" class="form-control" name="city"
                                [ngClass]="{ 'is-valid': (requestorForm?.get('city')?.dirty  ) && !requestorForm?.get('city')?.errors, 'is-invalid': (requestorForm?.get('city')?.dirty  ) && requestorForm?.get('city')?.errors }">
                                <div class="invalid-feedback">
                                  @if ( requestorForm?.get('city')?.errors && requestorForm?.get('city')?.errors['required']) {
                                    <span class="text-danger-show"
                                    >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                  }
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <label for="state" class="control-label">{{'requestorForm.state'|cxTranslate}}</label>
                                <div class="select-box">
                                  <select name="state" class="form-control" formControlName="state"
                                    [ngClass]="{ 'is-valid': (requestorForm?.get('state').dirty  ) && !requestorForm?.get('state')?.errors, 'is-invalid': (requestorForm?.get('state').dirty  ) && requestorForm?.get('state')?.errors }">
                                    <option [ngValue]="null" disabled selected>
                                    {{'common.register_state_placeholder'|cxTranslate}}</option>
                                    @for (item of stateList?.regionsWSList; track item) {
                                      <option [ngValue]="item.isocode">
                                      {{item.name}}</option>
                                    }
                                  </select>
                                  <div class="invalid-feedback">
                                    @if ( requestorForm?.get('state')?.errors && requestorForm?.get('state')?.errors['required']) {
                                      <span class="text-danger-show"
                                        >
                                        <span>{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-top-25">

                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <label for="zip" class="control-label">{{'requestorForm.zipPostalCode'|cxTranslate}}</label>
                                <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip"
                                  [ngClass]="{ 'is-valid': (requestorForm?.get('zip')?.dirty  ) && !requestorForm?.get('zip')?.errors, 'is-invalid': (requestorForm?.get('zip')?.dirty  ) && requestorForm?.get('zip')?.errors }">
                                  <div class="invalid-feedback">
                                    @if ( requestorForm?.get('zip')?.errors && requestorForm?.get('zip')?.errors['required']) {
                                      <span class="text-danger-show"
                                      >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                    }
                                  </div>

                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                  @if ((pageFieldData$|async); as pageFieldData) {
                                    <label for="country"
                                    class="control-label">{{'requestorForm.country'|cxTranslate}}</label>
                                    <div class="select-box">
                                      <select name="country" class="form-control" formControlName="country"
                                        (change)="onCountryChange($event)"
                                        [ngClass]="{ 'is-valid': (requestorForm?.get('country')?.dirty  ) && !requestorForm?.get('country')?.errors, 'is-invalid': (requestorForm?.get('country').dirty  ) && requestorForm?.get('country')?.errors }">
                                        <option [ngValue]="null" disabled selected>
                                        {{'common.form_register_empty'|cxTranslate}}</option>
                                        @for (item of pageFieldData['countriesWSList']; track item) {
                                          <option
                                            [ngValue]="item.isocode">
                                          {{item.name}}</option>
                                        }
                                      </select>
                                      <div class="invalid-feedback">
                                        @if ( requestorForm?.get('country')?.errors && requestorForm?.get('country')?.errors['required']) {
                                          <span class="text-danger-show"
                                          >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>

                              <div class="endsure-btnblock">
                                <button class="btn-action btn-back mt-4" (click)="back()">
                                  <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
                                {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

                                <button class="btn-action btn-next mt-4" [disabled]="!allowNext"
                                  (click)="next()">{{'dataExtractionRquest.Next'|cxTranslate}}
                                  <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
                                </button>

                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Popup for customerName -->
                    @if (popupOpenCompanyName) {
                      <div class="popup-backdrop"></div>
                    }

                    @if (popupOpenCompanyName) {
                      <div class="popup-modal">
                        <div class="popup-header">
                          <button class="close-btn" aria-label="close dialog" (click)="closePopupCompanyName()">
                            <img src="/icons/close-light-grey.svg" alt="" />
                          </button>
                        </div>
                        <div class="popup-body">
                          <span class="popup-title">{{'requestorForm.company_name_popup_title'|cxTranslate}}</span>
                          <p class="mt-3">{{'requestorForm.company_name_popup_content'|cxTranslate}}</p>
                        </div>
                      </div>
                    }

                    <!-- Popup for contactName -->
                    @if (popupOpenContactName) {
                      <div class="popup-backdrop"></div>
                    }

                    @if (popupOpenContactName) {
                      <div class="popup-modal">
                        <div class="popup-header">
                          <button class="close-btn" aria-label="close dialog" (click)="closePopupContactName()">
                            <img src="/icons/close-light-grey.svg" alt="" />
                          </button>
                        </div>
                        <div class="popup-body">
                          <span class="popup-title">{{'requestorForm.contact_name_popup_title'|cxTranslate}}</span>
                          <p class="mt-3">{{'requestorForm.contact_name_popup_content'|cxTranslate}}</p>
                        </div>
                      </div>
                    }